angular
    .module("digitalLeasing.module")
    .component("derogaNuovoPrestoLeasing", {
        templateUrl: "ng/components/digitalLeasing/nuovoPrestoLeasing/derogaNuovoPrestoLeasing.view.html",
        bindings: {
            model: "=",
            validatePage: "&",
            invalidatePage: "&",
            snapshot: '<'
        },
        controllerAs: "derogaNuovoPrestoLeasingCtrl",
        controller: function derogaNuovoPrestoLeasing() {
            var self = this;
            self.$onInit = function () {
                if (!self.snapshot) {
                    self.invalidatePage();
                    self.model.leasingData.preventivo.nuovoPrestoleasingConDeroga = undefined;
                }
            }

            self.setAccettazione = function (value) {
                self.model.leasingData.preventivo.nuovoPrestoleasingConDeroga = value;
                self.validatePage();
            }
        }
    });